import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export function useSettings() {
  const [s, setS] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    api.get("/admin/settings").then((r) => setS(r.data));
  }, []);
  const set = useCallback((path, value) => {
    setS((cur) => {
      const next = structuredClone(cur);
      const keys = path.split(".");
      let o = next;
      keys.slice(0, -1).forEach((k) => { o[k] = o[k] ?? {}; o = o[k]; });
      o[keys[keys.length - 1]] = value;
      return next;
    });
  }, []);
  const save = async () => {
    setSaving(true);
    try { await api.put("/admin/settings", s); toast.success("Saved — the public site now shows these changes"); }
    catch (e) { toast.error(errMsg(e)); } finally { setSaving(false); }
  };
  return { s, set, save, saving };
}
